import { render, staticRenderFns } from "./ComplieShowImg.vue?vue&type=template&id=c2ecad08&scoped=true"
import script from "./ComplieShowImg.vue?vue&type=script&lang=js"
export * from "./ComplieShowImg.vue?vue&type=script&lang=js"
import style0 from "./ComplieShowImg.vue?vue&type=style&index=0&id=c2ecad08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ecad08",
  null
  
)

export default component.exports